class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId || "cart-drawer-recommendations";
    this.limit = parseInt(this.dataset.limit, 10) || 2;
    this.intent = this.dataset.intent || "related";
    this.list = this.querySelector("[data-cart-recos-list]");
    this.heading = this.querySelector("[data-cart-recos-heading]");
    this.fetchAbort = null;
  }

  connectedCallback() {
    this.refresh();
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      this.unsubscribe = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => this.refresh());
    }
    this.addEventListener("click", (e) => this.onClick(e));
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.fetchAbort) this.fetchAbort.abort();
  }

  async refresh() {
    const productId = await this.getLastCartProductId();
    if (!productId) {
      this.setAttribute("hidden", "");
      if (this.list) this.list.innerHTML = "";
      return;
    }
    const url = `${window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.product_recommendations_url || "/recommendations/products"}?section_id=${encodeURIComponent(this.sectionId)}&product_id=${productId}&limit=${this.limit}&intent=${this.intent}`;

    if (this.fetchAbort) this.fetchAbort.abort();
    this.fetchAbort = new AbortController();

    try {
      const res = await fetch(url, { signal: this.fetchAbort.signal });
      if (!res.ok) throw new Error("recos fetch failed: " + res.status);
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const inner =
        parsed.querySelector(".m-cart-recos__list") ||
        parsed.querySelector("[id^='shopify-section-']")?.firstElementChild;
      if (this.list && inner) {
        this.list.innerHTML = inner.innerHTML;
        this.removeAttribute("hidden");
      } else {
        this.setAttribute("hidden", "");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        console.warn("[cart-drawer-recommendations]", err);
        this.setAttribute("hidden", "");
      }
    }
  }

  async getLastCartProductId() {
    try {
      const res = await fetch(`${window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_url || "/cart"}.js`, {
        headers: { Accept: "application/json" },
      });
      const cart = await res.json();
      if (!cart || !cart.items || cart.items.length === 0) return null;
      const last = cart.items[cart.items.length - 1];
      return last.product_id;
    } catch (e) {
      return null;
    }
  }

  onClick(e) {
    const addBtn = e.target.closest("[data-cart-reco-add]");
    if (addBtn) return this.addToCart(addBtn);

    const prevBtn = e.target.closest("[data-recos-prev]");
    const nextBtn = e.target.closest("[data-recos-next]");
    
    if (prevBtn || nextBtn) {
      if (!this.list) return;
      const card = this.list.querySelector('.m-cart-reco-card');
      const scrollAmount = card ? card.offsetWidth + 12 : this.list.clientWidth;
      this.list.scrollBy({ left: prevBtn ? -scrollAmount : scrollAmount, behavior: "smooth" });
      return;
    }


    const dec = e.target.closest("[data-qty-decrease]");
    const inc = e.target.closest("[data-qty-increase]");
    if (dec || inc) return this.changeQty(dec ? -1 : 1, e.target.closest("[data-qty]"));
  }

  changeQty(delta, qtyEl) {
    if (!qtyEl) return;
    const valueEl = qtyEl.querySelector("[data-qty-value]");
    if (!valueEl) return;
    const current = parseInt(valueEl.textContent, 10) || 1;
    const next = Math.max(1, current + delta);
    valueEl.textContent = String(next).padStart(2, "0");
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const card = btn.closest(".m-cart-reco-card");
    const qtyEl = card && card.querySelector("[data-qty-value]");
    const quantity = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

    btn.disabled = true;
    btn.dataset.loading = "true";

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", String(quantity));
    if (sectionsToBundle.length) {
      formData.append("sections", sectionsToBundle.join(","));
      formData.append("sections_url", window.location.pathname);
    }

    const cartAddUrl =
      (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) ||
      "/cart/add.js";

    try {
      const res = await fetch(cartAddUrl, {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });
      const response = await res.json();
      if (response.status) {
        console.warn("[cart-drawer-recommendations] add error:", response);
        return;
      }
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          source: "cart-drawer-recommendations",
          cart: response,
          productVariantId: variantId,
        });
      }
    } catch (err) {
      console.warn("[cart-drawer-recommendations] add error", err);
    } finally {
      btn.disabled = false;
      delete btn.dataset.loading;
    }
  }
}

customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
